import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { SuppliesPromotionSchema } from "./promotion";

export const getSuppliesPromotions = unaryRpc({
  name: "getSuppliesPromotions" as const,
  input: z.object({}),
  output: z.object({ promotions: z.array(SuppliesPromotionSchema) }),
});
